export default __webpack_public_path__ + "static/media/client1.6f9f2960.png";